import difference from 'lodash.difference';

const itemsDeletedCount = (initialItems, updatedItems) =>
  difference(
    initialItems.map((a) => a.id),
    updatedItems.map((a) => a.id)
  ).length;

export default itemsDeletedCount;
